exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".poWrapper {\n  position: fixed;\n  left:0;right:0;top:0;bottom:0;\n  background:white;\n  z-index:1111;\n}\nh1 {\n  border-top:2px solid black;\n  border-bottom:2px solid black;\n}\ntable {\n  width: 100%;\n}\ntd {\n  vertical-align: top;\n}\ntd.half {\n  width:50%;\n}\n.bordered {\n  border:1px solid black;\n}\ntd.quarter {\n  width:25%;\n}\nth {\n  color:white;\n  background-color: black;\n}\n.order-table td, .order-table th{\n  border:1px solid #666666;\n}\n.ten {\n  width:15%;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/po.component.css
// module id = 438
// module chunks = 0